module.exports = __webpack_public_path__ + "static/media/15ditton.58ac5330.jpg";